var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareChannel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4425 10.6325L11.565 13.6175M11.5575 5.3825L6.4425 8.3675M15.75 4.25C15.75 5.49264 14.7426 6.5 13.5 6.5C12.2574 6.5 11.25 5.49264 11.25 4.25C11.25 3.00736 12.2574 2 13.5 2C14.7426 2 15.75 3.00736 15.75 4.25ZM6.75 9.5C6.75 10.7426 5.74264 11.75 4.5 11.75C3.25736 11.75 2.25 10.7426 2.25 9.5C2.25 8.25736 3.25736 7.25 4.5 7.25C5.74264 7.25 6.75 8.25736 6.75 9.5ZM15.75 14.75C15.75 15.9926 14.7426 17 13.5 17C12.2574 17 11.25 15.9926 11.25 14.75C11.25 13.5074 12.2574 12.5 13.5 12.5C14.7426 12.5 15.75 13.5074 15.75 14.75Z",
    stroke: "#005386",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareChannel);
export default __webpack_public_path__ + "static/media/IconShareChannel.7b9607175666ed7a6da3cc34bb23ea6b.svg";
export { ForwardRef as ReactComponent };